import SectionHead from "./SectionHead";
import { formatPoints } from "@/mocks/homeData";

export default function FormatGuide() {
  return (
    <section id="format" className="bg-background-100 py-16 md:py-24" aria-label="投稿格式规范">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="投稿格式"
          title="掌握规范，一次过审"
          desc="投稿不是越长越好，格式清爽、证据清晰的内容采纳率更高。记住这 6 条，投稿事半功倍。"
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {formatPoints.map((point, i) => (
            <article
              key={point.title}
              className="group flex gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-400"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500/20 text-accent-800">
                <i className={`${point.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-serifsc text-xs font-bold text-accent-700">0{i + 1}</span>
                  <h3 className="font-serifsc text-base font-bold text-foreground-950">{point.title}</h3>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}